import { WidgetDefinition } from '../models/WidgetDefinition';

export const alarmsHeatMapWidgetDefinition: WidgetDefinition = {
    baseType: 'AlarmsHeatMap',
    group: 'Charts',
    hasImage: true,
    highlights: ['Number of alarms raised during selected period of time, per group and per severity', 'Color intensity highlights groups with more alarms'],
    icon: 'fa-table',
    sortingOrder: 1501,
    title: 'Alarms heat map',
    type: 'AlarmsHeatMap'
};